import React from 'react';
import { useLocation } from 'react-router-dom';
import { LogOut, ShieldOff } from 'lucide-react';
import { ButtonLink } from '@shared/components';

export const AccessDenied: React.FC = () => {
    const location = useLocation();
    const from = (location.state as { from?: string } | null)?.from;

    return (
        <div className="min-h-screen flex items-center justify-center bg-mp-background px-4">
            <div className="max-w-lg w-full text-center">
                <div className="mb-8">
                    <div className="flex justify-center mb-4">
                        <ShieldOff className="w-16 h-16 text-mp-error" />
                    </div>
                    <h1 className="text-4xl font-bold text-mp-foreground mb-2">
                        Access Denied
                    </h1>
                    <p className="text-mp-muted mb-2">
                        You don&apos;t have permission to view this page.
                    </p>
                    {from && (
                        <p className="text-sm text-mp-muted font-mono">
                            {from}
                        </p>
                    )}
                </div>
                <ButtonLink to="/logout" size="sm" startIcon={<LogOut className="w-4 h-4" />}>
                    Sign out
                </ButtonLink>
            </div>
        </div>
    );
};
